import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams , useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import { SWAL_SETTINGS, THEME_COLORS } from "../../../../utils/Constants";
import { capitalizeFirstLetter, formatDateWithTime, formateDateWithMonth, handleServerValidations, TrimText } from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import { List } from "../../services/pendingappointment.service";
import { Placeholder, Tooltip, Whisper } from "rsuite";
import { accociateUpdate, AssociateList } from "../../services/appointment.service";

const AssignAssociate = () => {
  const { t } = useTranslation();
  const params = useParams();

 
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(10);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
 

 

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Assign Associates", url: "" },
  ];

  const [associateData, setAssociateData] = useState([]);

  /********** MULTI SELECT <<<<<<********* */



  // useEffect(() => {
  //   if (!params?._id) return;

  //   AssociateList(params._id)
  //     .then((response) => {
  //       console.log("AssociateList response:", response);
  //       setAssociateData(response?.data || []);
  //       setDataLength(response.data.length)
  //       setLoader(false);
  //     })
  //     .catch((error) => {
  //       console.log("AssociateList error:", error);
  //       setAssociateData([]);
  //       setLoader(false);
  //     });
  // }, [params._id]);

  useEffect(() => {
    if (!params?._id) return;
  
    const timer = setTimeout(() => {
      setLoader(true);
  
      const formData = new FormData();
      formData.append("_id", params._id);
      formData.append("page", params.pgno || 1);
      formData.append("per_page", itemperpage);
  
      AssociateList(formData)
        .then((response) => {
          const data = response?.data || {};
  
          setAssociateData(data.list || []);
          setDataLength(data.total_records || 0);
          setPage(data.page || 1);
  
          setLoader(false);
        })
        .catch((error) => {
          console.log("AssociateList error:", error);
          setAssociateData([]);
          setLoader(false);
        });
  
    }, 300);
  
    return () => clearTimeout(timer);
  
  }, [params._id, params.pgno, itemperpage]);
  

  const handleSubmit = (_id) => {


    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("You want to assign?"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("Yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        formdata.append("_id", _id);
        formdata.append("appointment_id", params._id);

        accociateUpdate(formdata)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              }).then(() => {
                navigate(-1);
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("Update error:", error);
            Swal.fire({
              icon: "error",
              text: "Something went wrong!",
              ...SWAL_SETTINGS,
            });
          });
      }
    });
  };



  

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Assign Associate</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
            
                </div>


               
              </div>
            </div>
            {
              loader?
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              :
            <>
            <div className="table-responsive min-h-400">
              <table className="table table-bordered card-table border-top text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>

                    <th>{t("label_name")}</th>
                    <th>{t("label_user_email")}</th>
                    <th>{t("label_phone_number")}</th>
                    
                    

                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
               
                    <>
                      {associateData.length ? (
                        associateData.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                              <td>{row?.name ? capitalizeFirstLetter(row?.name) : "N/A"}</td>
                              <td>{row?.email ? row?.email : "N/A"}</td>
                              <td>{row?.phone_number ? row?.phone_number : "N/A"}</td>

                              <td>
                                <button className="btn btn-primary" onClick={()=>{handleSubmit(row._id)}}>Assign</button>
                              </td>
                              


                             
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Appointment",
                    path: `/admin/appointments/assign-associate/list/${params._id}`,
                  },
                ]}
              />
            ) : (
              ""
            )}
            </>}
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignAssociate;
